import { styled } from '@mui/system';
import { Box, Typography, Stack } from '@mui/material';

import { EmojiHappy } from "assets/icons";

const InformationBoxRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.neutralButtonsBg,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1)
}));

const HeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  "& > svg": {
    margin: theme.spacing(0, 2, 0, 1)
  },
  ".MuiTypography-root": {
    color: theme.vars.palette.primary.main,
    margin: theme.spacing(0, 1),
    fontSize: '1rem'
  }
}));

const InformationBox = ({ title, onCancel, ...props }) => {

  return (
    <InformationBoxRoot {...props}>
      <Stack direction='row' justifyContent='space-between' alignItems='start'>
        <HeaderBox>
          <EmojiHappy />
          <Typography sx={{ whiteSpace: 'pre-wrap' }}>{title}</Typography>
        </HeaderBox>
      </Stack>
    </InformationBoxRoot >
  );
}

export default InformationBox;
